export default __webpack_public_path__ + "static/media/RB_QuickFill.fddbb845.jpg";